import axios from "@/services/axios";

/**
 * @returns Repository API client for filtering research infrastructure and research equipment
 */
export default function ResearchCategoryRepositoryAPI() {
  async function loadCategories(): Promise<any> {
    return await axios.get(`api/v1/ResearchCategory`).then((response: any) => {
      return response.data;
    });
  }

  async function loadTargetGroups(): Promise<any> {
    return await axios
      .get(`api/v1/EquipmentTargetGroup?PageNumber=0&PageSize=50`)
      .then((response: any) => {
        return response.data;
      });
  }

  return {
    loadCategories,
    loadTargetGroups,
  };
}
